
<div
    class="Card"
    :class="[`is-${size}`, `is-${variant}`, { 'is-rounded': rounded, 'is-elevated': elevated }]"
>
    <slot></slot>
</div>
